import { IExperiment } from '../api/experiments';

export function getAbExperiment(experiments: IExperiment[], experimentName: string) {
  return experiments.find(({ name }) => name === experimentName);
}

export const getAbGroup = (experiment?: IExperiment | undefined) => {
  if (experiment) {
    return {
      isOK: true,
      group: experiment.abGroup,
    };
  }

  return {
    isOK: false,
  };
};

export const checkExperiment = (experiments: IExperiment[], experimentName: string, certainGroup?: number) => {
  const experiment = getAbExperiment(experiments, experimentName);
  const { isOK, group } = getAbGroup(experiment);

  if (isOK) {
    if (certainGroup) {
      return group === certainGroup;
    }

    return group !== 0;
  }

  return isOK;
};

export const isAbExperiment = (experiments: IExperiment[], experimentName: string) => {
  return checkExperiment(experiments, experimentName, 0);
};
